
import api from 'api';
import { processPromise, obj2Prams } from '@helpers/functions';

const contato = {};

contato.retrieve = (params = {}) => {
  const querystring = obj2Prams(params);

  return new Promise((resolve, reject) => {
    let endpoint = `/contatos`;
    endpoint = querystring ? `${endpoint}?${querystring}` : endpoint;

    api.get(endpoint).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

contato.show = (_id) => {
  return new Promise((resolve, reject) => {
    let endpoint = `/contato/${_id}`;
    api.get(endpoint).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

contato.save = (_id, data) => {
  return new Promise((resolve, reject) => {
    let endpoint = `/contato`;
    endpoint = _id ? `${endpoint}/${_id}` : endpoint;
    api.post(endpoint, data).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

contato.export = () => {
  return new Promise((resolve, reject) => {
    let endpoint = `/contato/export`;
    api.patch(endpoint, {},{ responseType: 'blob' }).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

export default contato
